import React from "react";

interface MenuIconProps extends React.HTMLAttributes<HTMLDivElement> {
  isOpened: boolean;
}

const MenuIcon: React.FC<MenuIconProps> = ({
  isOpened,
  className,
  ...props
}) => {
  return (
    <div
      className={`relative flex h-6 w-6 cursor-pointer flex-col items-center justify-between py-1 ${className}`}
      {...props}
    >
      <div
        className={`h-0.5 w-full bg-current transition-all duration-300 ease-in-out 
          ${isOpened ? "translate-y-[0.49rem] rotate-45" : ""}`}
      ></div>

      <div
        className={`h-0.5 w-full bg-current transition-all duration-300 ease-in-out 
          ${isOpened ? "opacity-0" : ""}`}
      ></div>

      <div
        className={`h-0.5 w-full bg-current transition-all duration-300 ease-in-out 
          ${isOpened ? "-translate-y-[0.375rem] -rotate-45" : ""}`}
      ></div>
    </div>
  );
};

export default MenuIcon;
